import React, { useState , useContext } from 'react';
import '../../assets/css/viewtrree.css';
import Stage3DataPanel from './Stage3DataPanel';
import {DataContext} from './DataContext';
import { ErrorBoundary } from '../common/ErrorBoundary'
import Loader from '../common/Loader'

export default function Stage3() {
   const { products, geography, isloading } = useContext(DataContext);

    const ZoneList = [
        {
            "zoneId": 1,
            "zoneName": 'Product Heirarchy',
            "zoneHeaderName": 'SKU\'s',
            "heirarchyHeaderName" : "Categories \\ Brands"
        },
        {
            "zoneId": 2,
            "zoneName": 'Geography',
            "zoneHeaderName": 'Cities',
            "heirarchyHeaderName" : "Locations"
        },
        {
            "zoneId": 3,
            "zoneName": 'Channel',
            "zoneHeaderName": 'Retailers',
            "heirarchyHeaderName" : "Manufacturers"
        },
    ]


    const [selZone, setSelZone] = useState(null)
    const [HeirarchyData, setHeirarchyData] = useState(null);

    const onClickHandler = (e) => {
        const { id } = e.target;
        const zone = ZoneList.find(zone => zone.zoneId == id);
        setSelZone(zone);
        
        switch (id) {
            case "1":    
                setHeirarchyData(products?.data);
                break;
            case "2": 
                setHeirarchyData(geography?.data);
                break;
            case "3": 
                break;
            default: setHeirarchyData(null);
                break;
        }
    }

    if(isloading){
        return (   <ErrorBoundary>
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="createworkflowtabcontents">                    
                        <div id="stage3">
                            <div className="col-md-12 col-sm-12 col-xs-12 text-center" >
                                  <Loader size={'large'} />                           
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </ErrorBoundary>)
    }

    return (
        <ErrorBoundary>
        <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="createworkflowtabcontents">                    
                    <div id="stage3">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <ul className="datatabselect" data-persist="true">
                                <li>
                                    <button onClick={onClickHandler} id="1" aria-label="DE">PRODUCT HEIRARCHY</button>
                                </li>
                                <li><button onClick={onClickHandler}  id="2" aria-label="DE">GEOGRAPHY</button></li>
                                {/* <li><button onClick={onClickHandler} disabled id="3" aria-label="DE">CHANNEL</button></li> */}
                            </ul>
                          
                            {selZone && 
                            <Stage3DataPanel 
                            key={selZone.zoneId} 
                            zone={selZone}
                            zoneHeaderName={selZone.zoneHeaderName} 
                            heirarchyHeaderName={selZone.heirarchyHeaderName}
                            heirarchyData={HeirarchyData} />}
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </ErrorBoundary>
       
    )
}
